<!-- Main container with a professional layout -->
<div class="main-container">
    <!-- Floating Logo -->
    <nav class="navbar">
        <div class="navbar-left">
            <img src="assets/img/LOGO_XPIndia_Square.png" alt="XP India Logo" class="navbar-logo" />
        </div>
    </nav>


    <!-- Main content area -->
    <div class="content-container">

        <div class="container">
            <div class="row align-items-center">

                <!-- Left side - Hero section -->
                <div class="col-md-6 col-sm-12 hero-section">
                    <mat-card class="hero-card">
                        <mat-card-content>
                            <h1 class="hero-card-title">
                                Check Your Order Status
                            </h1>
                            <img src="assets/img/tracking-icon_111.png" alt="Order Tracking" class="hero-card-image" />
                        </mat-card-content>
                    </mat-card>
                </div>




                <!-- Right side - Tracking form -->
                <div class="col-md-6 col-sm-12">
                    <div class="tracking-form-container">
                        <div class="tracking-form-wrapper">

                            <!-- CSV Actions -->
                            <div class="csv-actions" id="csv">
                                <button mat-raised-button type="button" class="action-button download"
                                    (click)="downloadSampleExcel()">
                                    <mat-icon>cloud_download</mat-icon>
                                    <span>Sample CSV</span>
                                </button>
                                <button mat-raised-button type="button" class="action-button upload"
                                    (click)="triggerFileInput()">
                                    <mat-icon>attach_file</mat-icon>
                                    <span>Upload CSV</span>
                                </button>
                            </div>

                            <input #fileInput type="file" accept=".csv" style="display: none;"
                                (change)="onFileSelected($event)" />

                            <div class="form-header">
                                <h2 class="form-title">Track Your Order</h2>
                                <p class="form-subtitle">Search By : Order Id (or) XPCN/XPLS Number (Consignment Number)
                                </p>
                            </div>


                            <!-- Tracking Form -->
                            <form [formGroup]="filterForm" (ngSubmit)="onSubmit()" class="tracking-form">
                                <mat-form-field appearance="outline" class="tracking-input">
                                    <mat-label>Enter Order ID or XPCN/XPLS Number</mat-label>
                                    <input matInput (ngModelChange)="keywordchanged()"
                                        placeholder="Enter Order ID or XPCN/XPLS Number" formControlName="Keyword"
                                        (paste)="onPaste($event)">
                                </mat-form-field>

                                <button mat-raised-button class="track-button" type="submit"
                                    [disabled]="filterForm.invalid">

                                    <span>{{TrackBtn}}</span>
                                </button>
                            </form>


                            <div class="form-footer">
                                <app-applink></app-applink>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <footer class="footer">
        <div class="footer-container">

            <!-- Address Row -->
            <div class="footer-address">
                <div class="address-label">
                    Corporate<br />Address:
                </div>
                <div class="address-text">
                    OCUS Medley Tower, 14th Floor, Sector 99, Gurugram,<br />
                    Haryana 122001
                </div>
            </div>

            <!-- Email -->
            <div class="footer-email">
                <span>Email:</span>
                <a href="mailto:info@xpindia.in">info@xpindia.in</a>
            </div>

            <!-- Copyright -->
            <div class="footer-copy">
                © Copyright XPINDIA. All Rights Reserved
            </div>

        </div>
    </footer>



    <!-- Loading Spinner -->
    <div class="spinner-container" *ngIf="Isloader">
        <div class="spinner-content">
            <mat-spinner></mat-spinner>

        </div>
    </div>
</div>